var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "none" }, attrs: { id: "rating" } },
    [
      _vm._l(_vm.items, function (rating, index) {
        return _c(
          "div",
          { key: rating.id },
          [
            _c("rating", {
              attrs: { data: rating },
              on: {
                deleted: function ($event) {
                  return _vm.remove(index)
                },
              },
            }),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.enableRating
        ? _c("new-rating", {
            attrs: { data: _vm.type, slug: _vm.slug },
            on: { created: _vm.add },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }